import habitat from "preact-habitat";
import ThankPageWidgets from "./ThankPageWidgets";
import ReferralPopups from "./ReferralPopups";
import { fetchConfig } from "./internal_utilities/utilities";
import "./base.css";

window.renderMidas = async () => {
  // fetching config
  const data = await fetchConfig();

  if (window.Shopify && data) {
    // Saving the render config to window
    window.ofcoConfig = data;
    // Rendering Thank you page widgets, this is only run if there is no widgets already present in the window
    if (
      window.Shopify.checkout &&
      document.getElementsByClassName("coca-thank-page-widget").length === 0
    ) {
      let position1 = null;
      position1 = document.createElement("div");
      position1.setAttribute("class", "coca-thank-page-widget");
      position1.setAttribute("data-position", 1);
      position1.setAttribute("data-prop-type", "corner-widget");

      let position2 = null;
      position2 = document.createElement("div");
      position2.setAttribute("class", "coca-thank-page-widget");
      position2.setAttribute("data-position", 2);
      position2.setAttribute("data-prop-type", "corner-widget");

      let position3 = null;
      position3 = document.createElement("div");
      position3.setAttribute("class", "coca-thank-page-widget");
      position3.setAttribute("data-position", 3);
      position3.setAttribute("data-prop-type", "corner-widget");

      let position4 = null;
      position4 = document.createElement("div");
      position4.setAttribute("class", "coca-thank-page-widget");
      position4.setAttribute("data-position", 4);
      position4.setAttribute("data-prop-type", "corner-widget");

      let position5 = null;
      position5 = document.createElement("div");
      position5.setAttribute("class", "coca-thank-page-widget");
      position5.setAttribute("data-position", 5);
      position5.setAttribute("data-prop-type", "corner-widget");

      let paymentDetails = document.querySelector(
        'div[data-order-summary-section="payment-lines"]'
      );
      let titleDiv = document.getElementsByClassName("section__header")[0];
      let CustomerInformationDiv = document.getElementsByClassName(
        "content-box"
      )[document.getElementsByClassName("content-box").length - 1];

      paymentDetails.after(position1);
      titleDiv.before(position2);
      titleDiv.after(position3);
      CustomerInformationDiv.before(position4);
      CustomerInformationDiv.after(position5);
    }
    // rendering a div for referral gift popup
    if (!document.getElementById("referrer-gift-popup")) {
      let referrerGiftPopupDiv = document.createElement("div");
      referrerGiftPopupDiv.setAttribute("id", "referrer-gift-popup");
      document.body.appendChild(referrerGiftPopupDiv);
    }
  }
  habitat(ThankPageWidgets).render({
    selector: ".coca-thank-page-widget",
    inline: false,
    clean: false
  });

  habitat(ReferralPopups).render({
    selector: "#referrer-gift-popup",
    inline: false,
    clean: false
  });
};

window.renderMidas();

// re-render on dom ready
document.addEventListener("DOMContentLoaded", () => {
  window.renderMidas();
});
